import React, { useEffect } from "react";
import "./About.css";
import aboutbannerimg from "../Images/Group 1000001375.png";
import aboutmeetimg from "../Images/Group 1000001376.png";
import aboutmeetimg2 from "../Images/Group 1000001382.png";
import LastSecImg from "../Images/Group 48095663.png";
import { Link } from "react-router-dom";
// import { HashLink } from "react-router-hash-link";
import AOS from "aos"
import 'aos/dist/aos.css'
import Fade from 'react-reveal/Fade';


function About() {

  useEffect(() => {
  }, [])

  return (
    <div>
      <div className="container-fluid about-div1">
        <div className="container about-con-div1">
          <div className="row">
            <Fade left distance="6%" duration={1200}>

              <div className="col-lg-6 col-12" >
                <h1 className="about-banner-text1">Our Story Is Always Been</h1>
                <h1 className="about-banner-text2">
                  About telling <span>your</span> story
                </h1>
                <p className="about-banner-text3">
                  “Make your marketing goals and reach the finish line together with us”
                </p>
              </div>
            </Fade>
            <Fade right distance="6%" duration={1200}>

              <div className="col-lg-6 col-12" >
                <div className="d-flex justify-content-center">
                  <img src={aboutbannerimg} className="about-banner-img1" />
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </div>

      {/* section no 2 */}

      <div className="container-fluid pl-0 pr-0">
        <div className="container about-section2-container">
          <div className="about-color-svg2"></div>
          <div className="about-color-svg3"></div>
          <svg
            className="about-section2-svg1"
            width="97"
            height="128"
            viewBox="0 0 97 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 2C34.7632 30.3214 74.0789 23.7857 85 63"
              stroke="url(#paint0_linear_345_297)"
              stroke-width="5"
            />

            <circle cx="87" cy="69" r="8" stroke="#19E7A7" stroke-width="4" />
            <circle
              opacity="0.5"
              cx="33"
              cy="96"
              r="8"
              stroke="#2BAC85"
              stroke-width="4"
            />
            <circle
              opacity="0.5"
              cx="71.5"
              cy="121.5"
              r="5.5"
              stroke="#78FFD6"
              stroke-width="2"
            />
            <defs>
              <linearGradient
                id="paint0_linear_345_297"
                x1="85"
                y1="63"
                x2="-0.499998"
                y2="4.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#18FFB7" />
                <stop offset="1" stop-color="#272727" />
              </linearGradient>
            </defs>
          </svg>

          <div className="about-sec2text-div1">
            <Fade top distance="6%" duration={1200}>
              <p className="about-sec2-text1" >
                “We aim for marketing and innovation of businesses”
              </p>
            </Fade>
            <Fade top distance="6%" duration={1200}>
              <p className="about-sec2-text1" data-aos="fade-down">
                Based in the UK and USA, our teams work to deliver transformative digital marketing strategies backed by in-depth marketing analysis, variety of dimensions, ridiculously good customer service, and incredible advertising campaigns on various social media platforms. Our team of experts produces tailored strategic and technical edge to transform your business and help thrive in a digital era.
              </p>
            </Fade>
            <Fade top distance="6%" duration={1200}>
              <p className="about-sec2-text1 mb-0" data-aos="fade-down">
                {" "}
                In addition to striving to be the leading digital marketing agency in Europe when it comes to digital business development and marketing, we believe a direct and transparent collaboration is key to building a long lasting relationship with our client. It is our ambition to enter a meaningful partnership with you, where we truly can make a difference and where a combination of expertise, hard work and values such as trust and transparency is the foundation of a successful long term collaboration.
              </p>
            </Fade>
          </div>
          <svg
            className="about-section2-svg2"
            width="80"
            height="67"
            viewBox="0 0 49 67"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 7.15366C16.3407 0.694396 42.1778 -3.01968 22.8 33.7981C13.1111 53.1759 18 60.5 18 67"
              stroke="url(#paint0_linear_345_301)"
              stroke-width="5"
            />
            <circle cx="-5" cy="10" r="8" stroke="#19E7A7" stroke-width="4" />
            <defs>
              <linearGradient
                id="paint0_linear_345_301"
                x1="30"
                y1="71.043"
                x2="51.544"
                y2="23.4708"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#272727" />
                <stop offset="1" stop-color="#2ED19E" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>

      {/* Section no 3 */}

      <div className="container-fluid about-values-div1">
        <div className="container">
          <div className="row">
            <Fade top distance="6%" duration={1200}>
              <div className="col-lg-4 col-12">
                <h1 className="about-value-text1">
                  Our Core <br /> <span>Values</span>
                </h1>
                <p className="about-value-text2">
                  Remain the same regardless of the situation.
                </p>
              </div>
            </Fade>
            <Fade top distance="6%" duration={1200}>
              <div className="col-lg-8 col-12 mt-lg-0 mt-5">
                <div className="row">
                  <div className="col-sm-4 col-12 ">
                    <div className="about-card-div1">
                      <h1 className="about-card-text1">Futuristic</h1>
                    </div>
                  </div>
                  <div className="col-sm-4 col-12 mt-sm-0 mt-4">
                    <div className="about-card-div1">
                      <h1 className="about-card-text1">Growth-Oriented</h1>
                    </div>
                  </div>
                  <div className="col-sm-4 col-12 mt-sm-0 mt-4">
                    <div className="about-card-div1">
                      <h1 className="about-card-text1">Excellence</h1>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </div>

      {/* Section no 4 */}
      <Fade top distance="1%" duration={1000}>
        <div className="container-fluid meet-div1 pl-0 pr-0">
          <div className="about-color-svg"></div>
          <div className="about-color-svg1"></div>

          <div className="container">
            <div className="row justify-content-center align-items-center">
              <h1 className="meet-text1">
                Meet <br className="d-sm-block d-none"></br>Our
              </h1>
              <h1 className="meet-text2">Brains</h1>
            </div>
          </div>
          <div className="container meet-img-div d-lg-block d-none">
            <img
              src={aboutmeetimg}
              className="meet-img1 img-fluid"
              alt=""
              srcset=""
            />

            <div className="name-text-div1">
              <h1 className="name-text1">
                COO <br />
                <span>Jawad Rasoll</span>
              </h1>
            </div>
            <div className="name-text-div2">
              <h1 className="name-text1">
                COO <br />
                <span>Shahzad Ul Haq</span>
              </h1>
            </div>
            <div className="name-text-div3">
              <h1 className="name-text1">
                COO <br />
                <span>Shariq Ul Haq</span>
              </h1>
            </div>
          </div>
          <div className="container meet-img-div pl-0 pr-0 d-lg-none d-block">
            <img src={aboutmeetimg2} className="mobile-meet-img img-fluid" />
          </div>
        </div>
      </Fade>

      <Fade top distance="4%" duration={1200}>
        <div className="container-fluid pl-0 pr-0">
          <div className="container grow-div1">
            <div className="row">
              <div className="col-lg-6 col-12">
                <h1 className="grow-text1">
                  Want to grow your <br className="d-xl-block d-none" />{" "}
                  business.?{" "}
                </h1>
                <div className="grow-btn-div1 mx-sm-0 mx-auto ">
                  <Link to="/contact-us" className="grow-btn1">
                    {" "}
                    Let’s get started
                  </Link>
                </div>
              </div>
              <div className="col-lg-6 col-12 home-grow-img-div d-flex justify-content-center">
                <img src={LastSecImg} className="img-fluid home-grow-img" />
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}

export default About;
